module.exports = __webpack_public_path__ + "img/1.39259c81.jpg";